(function () {
  var STORAGE_PREFIX = 'claymore-cart-proof:';
  var MAX_AGE = 30 * 24 * 60 * 60 * 1000;
  var renderQueued = false;
  var lightbox = null;
  var lightboxImage = null;
  var lightboxTitle = null;
  var lightboxReturnFocus = null;

  function storageKey(setupId) {
    return STORAGE_PREFIX + setupId;
  }

  function removeExpiredProofs() {
    var now = Date.now();

    try {
      for (var index = window.localStorage.length - 1; index >= 0; index -= 1) {
        var key = window.localStorage.key(index);
        var stored;

        if (!key || key.indexOf(STORAGE_PREFIX) !== 0) continue;
        stored = JSON.parse(window.localStorage.getItem(key) || '{}');
        if (!stored.savedAt || now - stored.savedAt > MAX_AGE) window.localStorage.removeItem(key);
      }
    } catch (error) {
      // The product thumbnail remains available when browser storage is restricted.
    }
  }

  function save(setupId, proofs) {
    if (!setupId || !proofs || !proofs.front) return;

    try {
      removeExpiredProofs();
      window.localStorage.setItem(
        storageKey(setupId),
        JSON.stringify({
          front: proofs.front,
          back: proofs.back || '',
          savedAt: Date.now(),
        })
      );
    } catch (error) {
      // Storage limits should never prevent the shirt from being added to the cart.
    }
  }

  function read(setupId) {
    try {
      return JSON.parse(window.localStorage.getItem(storageKey(setupId)) || 'null');
    } catch (error) {
      return null;
    }
  }

  function createLabel(side) {
    var label = document.createElement('span');
    label.className = 'cm-cart-proof__label';
    label.textContent = side === 'back' ? 'Back' : 'Front';
    return label;
  }

  function getSideName(side) {
    return side === 'back' ? 'Back' : 'Front';
  }

  function createProofTile(side, src) {
    var tile = document.createElement('button');
    var image = document.createElement('img');
    var hint = document.createElement('span');

    tile.className = 'cm-cart-proof__tile cm-cart-proof__tile--' + side;
    tile.type = 'button';
    tile.dataset.claymoreProofOpen = '';
    tile.dataset.claymoreProofSide = side;
    tile.setAttribute('aria-label', 'Enlarge saved ' + side + ' placement proof');
    image.className = 'cart-item__image cm-cart-proof__image';
    image.src = src;
    image.alt = side === 'back' ? 'Saved back placement proof' : 'Saved front placement proof';
    image.loading = 'lazy';
    hint.className = 'cm-cart-proof__hint';
    hint.textContent = 'View larger';
    tile.appendChild(image);
    tile.appendChild(createLabel(side));
    tile.appendChild(hint);
    return tile;
  }

  function ensureLightbox() {
    var backdrop;
    var dialog;
    var closeButton;

    if (lightbox) return;
    lightbox = document.createElement('div');
    lightbox.className = 'cm-proof-lightbox';
    lightbox.hidden = true;
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-labelledby', 'ClaymoreProofLightboxTitle');

    backdrop = document.createElement('button');
    backdrop.className = 'cm-proof-lightbox__backdrop';
    backdrop.type = 'button';
    backdrop.setAttribute('aria-label', 'Close enlarged placement proof');
    backdrop.dataset.claymoreProofClose = '';

    dialog = document.createElement('div');
    dialog.className = 'cm-proof-lightbox__dialog';
    lightboxTitle = document.createElement('h2');
    lightboxTitle.id = 'ClaymoreProofLightboxTitle';
    lightboxTitle.className = 'cm-proof-lightbox__title';
    closeButton = document.createElement('button');
    closeButton.className = 'cm-proof-lightbox__close';
    closeButton.type = 'button';
    closeButton.setAttribute('aria-label', 'Close enlarged placement proof');
    closeButton.dataset.claymoreProofClose = '';
    closeButton.textContent = '\u00d7';
    lightboxImage = document.createElement('img');
    lightboxImage.className = 'cm-proof-lightbox__image';

    dialog.appendChild(closeButton);
    dialog.appendChild(lightboxTitle);
    dialog.appendChild(lightboxImage);
    lightbox.appendChild(backdrop);
    lightbox.appendChild(dialog);
    document.body.appendChild(lightbox);
  }

  function openLightbox(button) {
    var image = button.querySelector('img');
    var side = button.dataset.claymoreProofSide || 'front';

    if (!image) return;
    ensureLightbox();
    lightboxReturnFocus = button;
    lightboxTitle.textContent = getSideName(side) + ' placement proof';
    lightboxImage.src = image.src;
    lightboxImage.alt = image.alt;
    lightbox.hidden = false;
    document.body.classList.add('cm-proof-lightbox-open');
    lightbox.querySelector('.cm-proof-lightbox__close').focus();
  }

  function closeLightbox() {
    if (!lightbox || lightbox.hidden) return;
    lightbox.hidden = true;
    document.body.classList.remove('cm-proof-lightbox-open');
    if (lightboxReturnFocus) lightboxReturnFocus.focus();
  }

  function renderContainer(container) {
    var setupId = container.dataset.claymoreSetupId;
    var proof = read(setupId);
    var originalImage = container.querySelector('[data-claymore-cart-proof-front]');
    var frontTile;

    if (!proof || !proof.front || !originalImage) return;
    if (container.dataset.claymoreProofRendered === setupId) return;

    frontTile = document.createElement('button');
    frontTile.className = 'cm-cart-proof__tile cm-cart-proof__tile--front';
    frontTile.type = 'button';
    frontTile.dataset.claymoreProofOpen = '';
    frontTile.dataset.claymoreProofSide = 'front';
    frontTile.setAttribute('aria-label', 'Enlarge saved front placement proof');
    originalImage.src = proof.front;
    originalImage.removeAttribute('srcset');
    originalImage.alt = 'Saved front placement proof';
    frontTile.appendChild(originalImage);
    frontTile.appendChild(createLabel('front'));
    var frontHint = document.createElement('span');
    frontHint.className = 'cm-cart-proof__hint';
    frontHint.textContent = 'View larger';
    frontTile.appendChild(frontHint);

    container.replaceChildren(frontTile);
    if (proof.back) {
      container.appendChild(createProofTile('back', proof.back));
      container.classList.add('cm-cart-proof--two-sided');
    } else {
      container.classList.remove('cm-cart-proof--two-sided');
    }
    container.dataset.claymoreProofRendered = setupId;
  }

  function render() {
    document.querySelectorAll('[data-claymore-cart-proof]').forEach(renderContainer);
  }

  function queueRender() {
    if (renderQueued) return;
    renderQueued = true;
    window.requestAnimationFrame(function () {
      renderQueued = false;
      render();
    });
  }

  window.ClaymoreCartProofs = {
    save: save,
    render: render,
  };

  removeExpiredProofs();
  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    var openButton = target ? target.closest('[data-claymore-proof-open]') : null;
    var closeButton = target ? target.closest('[data-claymore-proof-close]') : null;

    if (openButton) {
      event.preventDefault();
      openLightbox(openButton);
    } else if (closeButton) {
      closeLightbox();
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeLightbox();
  });
  queueRender();
  new MutationObserver(queueRender).observe(document.documentElement, { childList: true, subtree: true });
})();
